import * as React from 'react';
import styled from '@emotion/styled';
import { Project } from '../../../types';

export interface ProjectInfoProps {
  project: Project;
  className?: React.ReactText;
  onClick: () => any;
}

const ProjectNamesContainer = styled('div')`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
`;

const ProjectContainer = styled('div')`
  display: flex;
  height: 100%;
  padding-right: 24px;
  cursor: pointer;
`;

export class ProjectInfo extends React.Component<ProjectInfoProps, {}> {
  constructor(props: ProjectInfoProps) {
    super(props);
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          minWidth: 0,
        }}
      >
        <ProjectContainer
          onClick={() => this.props.onClick()}
          className='bnt-hc-project-container'
          style={{
            display: 'flex',
            minWidth: 0,
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <ProjectNamesContainer>
            <div
              className={'bnt-hc-project-name'}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 12,
              }}
            >
              {this.props.project.number}
            </div>
            <div
              className={'bnt-hc-project-fullname'}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 12,
              }}
            >
              {this.props.project.name}
            </div>
          </ProjectNamesContainer>
        </ProjectContainer>
      </div>
    );
  }
}
